<template>
  <tr class="slds-hint-parent">
    <td>
      <button class="slds-button slds-button_icon" :title="$t('action.edit')" @click="$emit('edit', {id: row.sfmcId})">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="../../assets/symbols.svg#settings"></use>
        </svg>
      </button>
    </td>
    <th :data-label="$t('usersManagement.user.name')" scope="row">
      <div class="slds-truncate" :title="row.name">
        {{ row.name }}
      </div>
    </th>
    <td :data-label="$t('usersManagement.user.email')">
      <div class="slds-truncate" :title="row.email">
        {{ row.email }}
      </div>
    </td>
    <td :data-label="$t('usersManagement.user.role')">
      <div class="slds-truncate" :title="row.role ? $t(`usersManagement.user.roles.${row.role}`) : ''">
        <span v-if="row.role !== null">{{$t(`usersManagement.user.roles.${row.role}`)}}</span>
        <span v-else>&nbsp;</span>
      </div>
    </td>
    <td :data-label="$t('usersManagement.user.active')">
      <div class="slds-truncate">
        <span class="slds-icon_container slds-pill__remove">
          <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
            <use xlink:href="../../assets/symbols.svg#check" v-if="row.active" />
            <use xlink:href="../../assets/symbols.svg#close" v-else />
          </svg>
        </span>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  created () {
    this.row = this.value
  },
  data () {
    return {
      mode: 'read',
      oldRow: '',
      row: {}
    }
  },
  props: {
    value: Object
  },
  watch: {
    value: {
      handler (value) {
        this.row = value
      },
      deep: true
    }
  }
}
</script>
